import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TextTruncate from 'react-text-truncate';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import style from './styles/style.module.css';


class ListRowItem extends PureComponent {
    render() {
        const { list } = this.props;
        const author = list.author;
        const listSlug = `/${ author.slug }/${ list.slug }/`;

        return (
            <div className={ `${ style.listRowItem } ${ this.props.className }` }
            style={ { ...this.props.style } }
            data-hook='list-row-item'>
                <Link to={ listSlug }>
                    <div className={ style.imageWrapper }>
                        <ListCoverImage coverImage={ list.coverImage } videoId={ list.youtube } />
                    </div>
                    <div className={ style.details }>
                        <div className={ style.listTitle } title={ list.title }>{ list.title }</div>
                        <TextTruncate line={ 2 }
                        containerClassName={ style.listDescription }
                        text={ list.description } />

                    </div>
                </Link>
            </div>
        );
    }
}
ListRowItem.propTypes = {
    list: PropTypes.object.isRequired,
};

export default connect()( ListRowItem );
